import styled from 'styled-components';

import { Skeleton } from 'components/uikit/Skeleton/Skeleton';

export const PageHeader = styled.div`
  display: flex;
  flex-direction: column;
  row-gap: 20px;
`;

export const Title = styled(Skeleton).attrs({ height: '32px' })`
  max-width: 440px;
`;

export const Description = styled(Skeleton).attrs({ height: '20px' })`
  max-width: 360px;
`;

export const Content = styled.div`
  display: flex;
  flex-direction: column;
  row-gap: 16px;
`;

export const ContentHeader = styled.div`
  display: flex;
  flex-direction: row;
  column-gap: 12px;
`;

export const Button = styled(Skeleton).attrs({ height: '32px', width: '80px' })``;

export const Input = styled(Skeleton).attrs({ height: '44px' })``;
